import { ColDef, DoesFilterPassParams } from 'ag-grid-community';
import { CustomSetFilter } from '~/components/agGrid/filters/CustomSetFilter';

export const getSharedColumns = (specialtyField: string): ColDef[] => {
  return [
    {
      field: specialtyField,
      headerName: 'Specialty',
      filter: {
        component: CustomSetFilter,
        doesFilterPass: ({ model, node }: DoesFilterPassParams) => {
          if (!model || model.length === 0) return true;
          if (specialtyField === 'specialtyName') {
            return node.data?.specialtyName && model.includes(node.data?.specialtyName);
          }
          return node.data?.specialtyName.label && model.includes(node.data?.specialtyName.label);
        },
      },
    },
    {
      field: 'privilegeName',
      headerName: 'Privilege',
      tooltipComponent: 'agTooltipComponent',
      tooltipField: 'privilegeName',
      wrapText: false,
      autoHeight: false,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
    {
      field: 'privilegeType',
      filter: {
        component: CustomSetFilter,
        doesFilterPass: ({ model, node }: DoesFilterPassParams) => {
          if (!model || model.length === 0) return true;
          return model.includes(node.data.privilegeType);
        },
      },
    },
  ];
};

/** Sort privileges by specialty name → privilege type → privilege name (all ascending, case-insensitive) */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortPrivileges = <T extends Record<string, any>>(
  data: T[],
  specialtyField: string
): T[] =>
  [...data].sort((a, b) => {
    const specA =
      (typeof a[specialtyField] === 'object' ? a[specialtyField]?.label : a[specialtyField]) ?? '';
    const specB =
      (typeof b[specialtyField] === 'object' ? b[specialtyField]?.label : b[specialtyField]) ?? '';
    const specCmp = specA.localeCompare(specB, undefined, { sensitivity: 'base' });
    if (specCmp !== 0) return specCmp;
    const typeCmp = (a.privilegeType ?? '').localeCompare(b.privilegeType ?? '', undefined, {
      sensitivity: 'base',
    });
    if (typeCmp !== 0) return typeCmp;
    return (a.privilegeName ?? '').localeCompare(b.privilegeName ?? '', undefined, {
      sensitivity: 'base',
    });
  });

export const getEmptyPrivilegesForm = () => ({
  id: undefined,
  category: '',
  privilegeType: '',
  privilegeName: '',
  assignmentDate: new Date().toISOString().split('T')[0],
  privilegeNotes: '',
  specialtyName: { label: '', value: '' },
});
